import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { Table } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { getPlaceListForPrice } from "../../redux/actions/indexActions";
const PlaceZone = () => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.AuthReducer)
    const { indexReducer: { PricePlaceLists } } = useSelector((state) => state);
    const [allZones, setAllZones] = useState([]);
    const [formData, setFormData] = useState({
        tourist_type: "",
        place_id: "",
        status: 1,
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        dispatch(getPlaceListForPrice(auth.token));
    }, [dispatch, auth.token]);

    useEffect(() => {
        axios.get(`/api/admin/v1/get-tourist-type-list`, {
            headers: {
                Authorization: `Bearer ${auth.token}`,
            },
        }).then(({ data }) => {
            setAllZones(data.data || []);
        }).catch((err) => console.log(err));
    }, [auth.token]);
    console.log("allZones", allZones)
    const inputHandler = (e) => {
        const { name, value, checked, type } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
        }));
    };
    const handleDel = (id) => {
        if (window.confirm("Are You Sure You Want To Delete !")) {
            axios.delete(`/api/admin/v1/tourist-type-delete/${id}`, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`,
                },
            }).then((res) => {
                toast.success(res.data.message);
            }).catch((err) => toast.error("Somthing Went Wrong"));
        }
    };
    const handleSubmit = () => {
        const form = new FormData();
        for (const key in formData) { form.append(key, formData[key]); }
        axios.post(`/api/admin/v1/add-place-tourist-type`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
        }).catch((err) => {
            toast.error(err.response.data?.message || "An error occurred");
            setErrors(err.response.data);
        });
    };

    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <h4 className="text-white">Tourist Type</h4>
                </div>
            </div>
            <div className="bg-white px-3 py-3 rounded-2 my-4">
                <div className="row">
                    <div className="col-md-3 offset-md-1">
                        <FormGroup>
                            <Label>Tourist Type<span className="text-danger fs-4">*</span></Label>
                            <Input type="text" name="tourist_type" value={formData.tourist_type} onChange={inputHandler} invalid={Boolean(errors?.tourist_type)} />
                            <span className="d-block text-danger">{errors?.tourist_type}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-1 offset-md-1">
                        <FormGroup>
                            <Label>
                                All <span className="text-danger fs-4"></span>
                            </Label>
                            <Input type="checkbox" name="select_all" onChange={(e) => {
                                const allPlaceIds = e.target.checked ? PricePlaceLists.map((item) => item.id) : [];
                                inputHandler({ target: { name: "place_id", value: allPlaceIds } });
                            }} />
                            <span className="d-block text-danger">{errors?.place_id}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-3 offset-md-1">
                        <FormGroup>
                            <Label>Category <span className="text-danger fs-4">*</span></Label>
                            <Input type="select" name="place_id" multiple value={formData.place_id} onChange={(e) => {
                                const selectedOptions = Array.from(e.target.selectedOptions).map((option) => option.value);
                                inputHandler({ target: { name: "place_id", value: selectedOptions } });
                            }}>
                                <option value="" disabled>Select Category</option>
                                {PricePlaceLists.map((item) => (
                                    <option key={item.id} value={item.id}>{item.place_name}</option>
                                ))}
                            </Input>
                            <span className="d-block text-danger">{errors?.place_id}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-4 mt-3">
                        <Button color="primary" onClick={handleSubmit}>Submit</Button>
                        <Button className="ms-3" onClick={() => { }}>Cancel</Button>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-12">
                        <Table hover responsive>
                            <thead>
                                <tr>
                                    <th>SL. No.</th>
                                    <th>Tourist Type</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allZones.length === 0 ? (
                                    <tr><td colSpan="4">No data found</td></tr>
                                ) : (allZones.map((item, index) => (
                                    <tr key={item.id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{item.tourist_type}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <a href="" className="btn btn-warning" onClick={() => handleDel(item.id)}>Delete</a>
                                            </div>
                                        </td>
                                    </tr>
                                )))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlaceZone;
